"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const App_1 = require("./App");
const Batch_1 = require("./Batch");
const Model_1 = require("./Model");
const Codable_1 = require("./Codable");
const Collection_1 = require("./Collection");
const SubCollection_1 = require("./SubCollection");
const index_1 = require("./index");
require("reflect-metadata");
class Doc extends Model_1.Model {
    /**
     * constructor
     */
    constructor(reference) {
        super();
        this.createdAt = index_1.Timestamp.now();
        this.updatedAt = index_1.Timestamp.now();
        this._subCollections = {};
        let ref = undefined;
        if (reference instanceof Object) {
            ref = reference;
        }
        else if (typeof reference === "string") {
            ref = this.constructor.collectionReference().doc(`${reference}`);
        }
        if (ref) {
            this.documentReference = ref;
            this.parent = this.documentReference.parent;
            this.path = ref.path;
            this.id = ref.id;
        }
        else {
            this.documentReference = this.constructor.collectionReference().doc();
            this.parent = this.documentReference.parent;
            this.path = this.documentReference.path;
            this.id = this.documentReference.id;
        }
        for (const collection of this.subCollections()) {
            this._defineCollection(collection);
        }
    }
    static self() {
        const type = this;
        return type;
    }
    static modelName() {
        return this.toString().split('(' || /s+/)[0].split(' ' || /s+/)[1].toLowerCase();
    }
    static path() {
        return this.collectionReference().path;
    }
    static collectionReference() {
        return index_1.firestore.collection(this.modelName());
    }
    static documentReference(id) {
        if (id) {
            return this.collectionReference().doc(id);
        }
        else {
            return this.collectionReference().doc();
        }
    }
    modelName() {
        return this.constructor.modelName();
    }
    subCollection(path) {
        return this.documentReference.collection(path);
    }
    static init(reference) {
        const model = new this(reference);
        return model;
    }
    static fromData(data, reference, option) {
        const model = new this(reference);
        model._set(data, option);
        return model;
    }
    static fromSnapshot(snapshot, option) {
        const model = new this(snapshot.ref);
        model.snapshot = snapshot;
        const snapshotOption = {
            serverTimestamps: "estimate"
        };
        const data = snapshot.data(snapshotOption);
        if (data) {
            model._set(data, option);
        }
        return model;
    }
    _set(data, option) {
        super._set(data, option);
        this.createdAt = data["createdAt"] || index_1.Timestamp.now();
        this.updatedAt = data["updatedAt"] || index_1.Timestamp.now();
    }
    _defineCollection(key, value) {
        const descriptor = {
            enumerable: true,
            configurable: true,
            get: () => {
                return this._subCollections[key];
            },
            set: (newValue) => {
                if (newValue instanceof Collection_1.Collection) {
                    newValue.setCollectionReference(this.documentReference.collection(key));
                    this._subCollections[key] = newValue;
                }
            }
        };
        Object.defineProperty(this, key, descriptor);
    }
    static is(arg) {
        if (arg instanceof Object) {
            return Object.keys(arg).length === 3 &&
                arg.hasOwnProperty('id') &&
                arg.hasOwnProperty('path') &&
                arg.hasOwnProperty('data');
        }
        else {
            return false;
        }
    }
    data(option) {
        let data = {};
        for (const field of this.fields()) {
            const codingKey = this.codingKeys()[field];
            const descriptor = Object.getOwnPropertyDescriptor(this, field);
            if (descriptor && descriptor.get) {
                const value = descriptor.get();
                data[codingKey] = this._encode(value, field, option);
            }
            else {
                data[codingKey] = null;
            }
        }
        return data;
    }
    _encode(value, key, option) {
        if (value instanceof Doc) {
            const codingKeys = Reflect.getMetadata(Codable_1.CodableSymbol, this) || {};
            const modelType = codingKeys[key];
            if (modelType) {
                const convertDocument = (option === null || option === void 0 ? void 0 : option.convertDocument) || modelType.convert || false;
                if (convertDocument) {
                    return value.convert(option);
                }
            }
        }
        return super._encode(value, key, option);
    }
    _decode(value, key, option) {
        if (Doc.is(value)) {
            const codingKeys = Reflect.getMetadata(Codable_1.CodableSymbol, this) || {};
            const modelType = codingKeys[key];
            if (modelType) {
                const ref = App_1.App.shared().firestore().doc(value.path);
                const model = new modelType.type(ref);
                const convertDocument = (option === null || option === void 0 ? void 0 : option.convertDocument) || modelType.convert || false;
                model._set(value.data, Object.assign(Object.assign({}, option), { convertDocument }));
                return model;
            }
            else {
                return value;
            }
        }
        else {
            return super._decode(value, key, option);
        }
    }
    convert(option) {
        return {
            id: this.id,
            path: this.path,
            data: this.data(option)
        };
    }
    setData(data, option = { convertDocumentReference: false }) {
        this._set(data, option);
        return this;
    }
    fetch(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let snapshot;
                if (transaction) {
                    snapshot = yield transaction.get(this.documentReference);
                }
                else {
                    snapshot = yield this.documentReference.get();
                }
                this.snapshot = snapshot;
                const option = {
                    serverTimestamps: "estimate"
                };
                const data = snapshot.data(option);
                if (data) {
                    this._set(data);
                }
                return this;
            }
            catch (error) {
                throw error;
            }
        });
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            const batch = new Batch_1.Batch();
            batch.save(this);
            yield batch.commit();
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            const batch = new Batch_1.Batch();
            batch.update(this);
            yield batch.commit();
        });
    }
    delete() {
        return __awaiter(this, void 0, void 0, function* () {
            const batch = new Batch_1.Batch();
            batch.delete(this);
            yield batch.commit();
        });
    }
    static get(reference) {
        return __awaiter(this, void 0, void 0, function* () {
            let ref;
            if (reference instanceof index_1.DocumentReference) {
                ref = reference;
            }
            else {
                ref = this.collectionReference().doc(`${reference}`);
            }
            try {
                const snapshot = yield ref.get();
                if (snapshot.exists) {
                    const model = new this(snapshot.ref);
                    model.snapshot = snapshot;
                    const data = snapshot.data();
                    if (data) {
                        model._set(data);
                    }
                    return model;
                }
                else {
                    return undefined;
                }
            }
            catch (error) {
                throw error;
            }
        });
    }
    subCollections() {
        return Reflect.getMetadata(SubCollection_1.SubCollectionSymbol, this) || [];
    }
}
exports.Doc = Doc;
//# sourceMappingURL=Document.js.map